import {HttpHeaders, HttpParams} from '@angular/common/http';

export const getHttpParams = (props = {}): HttpParams => {
    const paramKeys = Object.keys(props)
        .filter(key => props[key] !== undefined && props[key] !== null && props[key] !== '');
    const params = {};
    paramKeys.forEach(key => params[key] = props[key].toString());
    return new HttpParams({
        fromObject: params
    });
};

export const SKIP_INTERCEPTORS_HEADER_CONST = 'SKIP_INTERCEPTORS';

export const RESET_PASSWORD_TOKEN_HEADER = 'reset-password-token';

export const skipInterceptors = (statuses: number[]) => {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set(SKIP_INTERCEPTORS_HEADER_CONST, statuses.join(','));
    return headers;
};
